export default __webpack_public_path__ + "static/media/logo.a0d7f052.png";